import { useQuery } from '@tanstack/react-query';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { IDealsQueryParams, IDealsResponse } from '../types';

const getDeals = async ({
    pageSize, currentPage, orgId, searchValue, sortBy, sortOrder, groupId, subprojectStageIds, selectedUnitType,
}: IDealsQueryParams): Promise<IDealsResponse> => {
    const includeSearch = searchValue ? `&search=${searchValue}` : '';
    const sortByValue = sortBy ? sortBy.split('.')[0] : '';
    const includeSort = sortByValue && sortOrder ? `&${sortByValue}=${sortOrder}` : '';
    const includeGroupId = groupId ? `&deal_group_id=${groupId}` : '';
    const includeSubprojectStageIds = subprojectStageIds ? `&${subprojectStageIds}` : '';
    const includeUnitType = selectedUnitType ? `&unit_type=${selectedUnitType}` : '';
    const response = await axiosInstance.get(
        // eslint-disable-next-line max-len
        `${API_ENDPOINTS.DEALS(orgId)}?page=${currentPage - 1}&page_size=${pageSize}${includeSearch}${includeSort}${includeGroupId}${includeSubprojectStageIds}${includeUnitType}`,
    );
    return response.data;
};

export const useGetDeals = ({
    pageSize, currentPage, orgId, searchValue, sortBy, sortOrder, groupId, subprojectStageIds, selectedUnitType,
}: IDealsQueryParams) => useQuery({
    queryKey: [QUERY_KEYS.DEALS, orgId, currentPage, pageSize, searchValue, sortBy, sortOrder, groupId, subprojectStageIds, selectedUnitType],
    queryFn: () => getDeals({
        pageSize, currentPage, orgId, searchValue, sortBy, sortOrder, groupId, subprojectStageIds, selectedUnitType,
    }),
    staleTime: 5000,
    refetchOnWindowFocus: true,
});
